import React from "react";
import { Activity, AlarmClock, ArrowRight, Compass, PhoneCall, ShieldCheck } from "lucide-react";

import { Card } from "../../ui/card";
import { LANE_STATUS_META } from "../config/stakeholderLaneConfig";

const summaryCards = [
  {
    key: "needs-now",
    title: "Needs Kevin Now",
    icon: ArrowRight,
  },
  {
    key: "moving",
    title: "Moving Well",
    icon: ShieldCheck,
  },
  {
    key: "watch",
    title: "Watch List",
    icon: Compass,
  },
  {
    key: "overdue",
    title: "Overdue Follow-Ups",
    icon: AlarmClock,
  },
  {
    key: "outreach",
    title: "Outreach Queue",
    icon: PhoneCall,
  },
];

export default function StakeholderSummaryStrip({ summary }) {
  const statusMeta = LANE_STATUS_META[summary.overallStatus];

  return (
    <div className="grid gap-3 xl:grid-cols-6">
      {summaryCards.map((card) => {
        const Icon = card.icon;
        const count =
          card.key === "overdue"
            ? summary.overdueCount || 0
            : card.key === "outreach"
              ? summary.outreachQueueCount || 0
              : summary.counts[card.key];

        return (
          <Card
            className="rounded-2xl border border-slate-200/80 bg-white/90 p-4 shadow-sm dark:border-white/10 dark:bg-[#11161d]"
            key={card.key}
          >
            <div className="flex items-center justify-between gap-4">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
                  {card.title}
                </p>
                <p className="mt-2 text-3xl font-semibold text-slate-950 dark:text-white">{count}</p>
              </div>
              <div className="rounded-2xl bg-slate-100 p-3 text-slate-700 dark:bg-white/10 dark:text-slate-100">
                <Icon className="h-5 w-5" />
              </div>
            </div>
          </Card>
        );
      })}

      <Card className="rounded-2xl border border-slate-200/80 bg-white/90 p-4 shadow-sm dark:border-white/10 dark:bg-[#11161d]">
        <div className="flex items-center justify-between gap-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
              Overall System
            </p>
            <p className="mt-2 text-lg font-semibold text-slate-950 dark:text-white">{statusMeta.label}</p>
            <p className="mt-1 text-sm text-slate-600 dark:text-slate-300">
              Board truth is centered on names, next moves, and visible drift.
            </p>
          </div>
          <div className={`rounded-2xl border p-3 ${statusMeta.className}`}>
            <Activity className="h-5 w-5" />
          </div>
        </div>
      </Card>
    </div>
  );
}
